import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { toast } from "react-toastify";
import {
  getNotificationPreferences,
  updateNotificationPreference,
  resetNotificationPreferences,
} from "../../../api/notificationApi";

const NotificationSettingsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const data = await getNotificationPreferences();
      if (data?.success) setItems(data.items || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const updateField = async (row, field, value) => {
    try {
      // Optimistic update
      setItems((prev) => prev.map((p) => (p.id === row.id ? { ...p, [field]: value } : p)));
      await updateNotificationPreference(row.id, { [field]: value });
    } catch (e) {
      toast.error("Failed to update preference");
      load();
    }
  };

  const handleReset = async () => {
    try {
      await resetNotificationPreferences();
      toast.success("Notification preferences reset to defaults");
      await load();
    } catch (e) {
      toast.error("Failed to reset preferences");
    }
  };

  const inAppBody = (row) => (
    <InputSwitch
      checked={row.in_app_enabled}
      onChange={(e) => updateField(row, "in_app_enabled", e.value)}
    />
  );

  const emailBody = (row) => (
    <InputSwitch
      checked={row.email_enabled}
      onChange={(e) => updateField(row, "email_enabled", e.value)}
    />
  );

  const audienceBody = (row) =>
    Array.isArray(row.audience) ? row.audience.join(", ") : "—";

  const header = (
    <div className="flex justify-content-between align-items-center">
      <h3 style={{ margin: 0 }}>Notification Settings</h3>
      <Button
        label="Reset to defaults"
        icon="pi pi-refresh"
        className="p-button-sm p-button-outlined"
        onClick={handleReset}
      />
    </div>
  );

  return (
    <div className="p-3">
      <Card>
        <p style={{ color: "var(--app-text-secondary)", marginTop: 0 }}>
          Toggle which events send in-app notifications or emails to users in this school.
        </p>
        <DataTable
          value={items}
          loading={loading}
          header={header}
          dataKey="id"
          rowGroupMode="subheader"
          groupRowsBy="category"
          sortField="category"
          sortOrder={1}
          emptyMessage="No preferences configured"
          rowGroupHeaderTemplate={(data) => (
            <strong style={{ color: "var(--primary-color)" }}>{data.category || "General"}</strong>
          )}
          rowGroupFooterTemplate={() => null}
        >
          <Column field="label" header="Event" style={{ minWidth: "16rem" }} />
          <Column field="event" header="Key" style={{ minWidth: "12rem" }} />
          <Column header="Audience" body={audienceBody} />
          <Column header="In-app" body={inAppBody} style={{ width: "7rem", textAlign: "center" }} />
          <Column header="Email" body={emailBody} style={{ width: "7rem", textAlign: "center" }} />
        </DataTable>
      </Card>
    </div>
  );
};

export default NotificationSettingsPage;
